import { Suspense, lazy } from 'react';

import { PageLoader } from '@/shared/ui';

const ResetPasswordAsync = lazy(() => import('./ui/ResetPassword'));

export const ResetPassword = () => {
  return (
    <Suspense fallback={<PageLoader />}>
      <ResetPasswordAsync />
    </Suspense>
  );
};
